/* DN: Klaviyo-Anbindung — Back-in-Stock (PDP).
   Konfiguration über data-Attribute am Script-Tag in layout/theme.liquid
   (Werte aus Theme-Einstellungen → Klaviyo). Nutzt die öffentliche Klaviyo
   Client API; es wird kein privater API-Key im Frontend verwendet.
   Newsletter-Anmeldungen laufen über snippets/newsletter-form.liquid +
   assets/klaviyo-newsletter.js (Double-Opt-in). */
(function () {
  var script = document.getElementById('dn-klaviyo-js');
  if (!script) return;

  var KEY = script.dataset.klaviyoKey;
  var LIST = script.dataset.klaviyoList;
  var REVISION = '2025-04-15';
  if (!KEY) return;

  function post(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    });
  }

  function emailGueltig(email) {
    return /.+@.+\..+/.test(email);
  }

  /* ---------- Back in Stock (PDP) ---------- */

  function zeigeBisMeldung(wrap, text, ok) {
    var msg = wrap.querySelector('.dn-bis__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.toggle('dn-bis__msg--ok', !!ok);
  }

  function sendeBis(wrap) {
    var input = wrap.querySelector('.dn-bis__input');
    var email = (input.value || '').trim();
    if (!emailGueltig(email)) {
      zeigeBisMeldung(wrap, 'Bitte gib eine gültige E-Mail-Adresse ein.', false);
      input.focus();
      return;
    }

    var btn = wrap.querySelector('.dn-bis__button');
    btn.disabled = true;

    post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + wrap.dataset.variantId }
          }
        }
      }
    })
      .then(function (r) {
        if (r.ok) {
          var row = wrap.querySelector('.dn-bis__row');
          if (row) row.hidden = true;
          zeigeBisMeldung(wrap, 'Alles klar! Wir benachrichtigen dich, sobald es wieder verfügbar ist.', true);
        } else {
          btn.disabled = false;
          zeigeBisMeldung(wrap, 'Das hat leider nicht geklappt. Bitte versuch es später noch einmal.', false);
        }
      })
      .catch(function () {
        btn.disabled = false;
        zeigeBisMeldung(wrap, 'Das hat leider nicht geklappt. Bitte versuch es später noch einmal.', false);
      });
  }

  /* Delegiert, damit es Variant-Rerender der Produkt-Form übersteht */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dn-bis] .dn-bis__button');
    if (btn) sendeBis(btn.closest('[data-dn-bis]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-dn-bis] .dn-bis__input');
    if (!input) return;
    e.preventDefault();
    sendeBis(input.closest('[data-dn-bis]'));
  });

})();
